export function hasAppliedFilters(state) {
  return Object.keys(state)
    .filter(key => key.endsWith('Refinements'))
    .some(key => {
      // Unwrap Vue observer
      const value = JSON.parse(JSON.stringify(state[key]));
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === 'object')
        return Object.values(value).some(entry => entry.length > 0);
      return false;
    });
}
